import Cookies from 'js-cookie'
// import axios from 'axios'
import ErrorHandler from './ErrorHandler'
import Loader from '@helpers/Loader'

export default class HttpClient {
    constructor (options = {}) {
        this.initDefaultOptions()
        const defaultOptions = _.cloneDeep(this.getDefaultOptions())
        const mergedOptions = _.merge(defaultOptions, options)

        this.setOptions(mergedOptions)
    }

    initDefaultOptions () {
        const defaultOptions = {
            // The base url
            baseUrl: this.getDefaultBaseUrl(),
            // The endpoint
            endpoint: '',
            // The url. If not specified, endpoint will be appended to baseUrl and it will be set as the url
            url: '',
            method: 'GET',
            dataType: 'json',
            headers: {},
            params: {}
        }

        this.appendCsrfHeader(defaultOptions)

        this.defaultOptions = defaultOptions
    }

    getDefaultOptions () {
        return this.defaultOptions
    }

    getDefaultBaseUrl () {
        // return process.env.MIX_APP_URL
        return window.config.baseUrl
    }

    setOptions (options) {
        Object.keys(options).forEach((key) => {
            this.setOption(key, options[key])
        })
    }

    setOption (key, value) {
        this.getOptions()[key] = value
    }

    getOptions () {
        let options = this.options
        if (!options) {
            this.options = {}
        }
        return this.options
    }

    getOption (key) {
        return this.getOptions()[key]
    }

    setEndpoint (value) {
        this.setOption('endpoint', value)
    }

    getEndpoint () {
        return this.getOption('endpoint')
    }

    setMethod (value) {
        this.setOption('method', value)
    }

    getMethod () {
        return this.getOption('method')
    }

    setHeaders (value) {
        this.setOption('headers', value)
    }

    getHeaders () {
        return this.getOption('headers')
    }

    addHeader (header, value) {
        let headers = this.getOption('headers')
        headers[header] = value
        this.setOption('headers', headers)
    }

    setParams (value) {
        this.setOption('params', value)
    }

    getParams () {
        return this.getOption('params')
    }

    addParam (param, value) {
        let params = this.getOption('params')
        params[param] = value
        this.setOption('params', params)
    }

    setBaseUrl (value) {
        this.setOption('baseUrl', value)
    }

    getBaseUrl () {
        return this.getOption('baseUrl')
    }

    send () {
        let options = this.getOptions()

        if (!options.url) {
            const url = this.generateUrl()
            this.setOption('url', url)
            options.url = url
        }

        if (this.shouldStartLoader()) {
            Loader.start()
        }

        options.httpClient = this

        return $.ajax(options)
            .done(function (response, textStatus, jqXHR) {
                let options = this.httpClient.options
                if (options.successHandler) {
                    let successHandler = options.successHandler

                    successHandler(response, textStatus, jqXHR, this.httpClient)
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                const status = jqXHR.status
                let options = this.httpClient.options
                let response = jqXHR.responseJSON
                let errorHandler = new ErrorHandler(status, response, jqXHR, this.httpClient)

                if (options.errorHandler) {
                    let statusCode = Object.keys(options.errorHandler)[0]

                    let customErrorHandler = options.errorHandler[statusCode]
                    if (!statusCode) {
                        statusCode = 'Master'
                    }
                    errorHandler.setHandlerForStatusCode(customErrorHandler, statusCode)
                }

                errorHandler.handle()
            })
            .always(function () {
                if (this.httpClient.shouldStopLoader()) {
                    Loader.stop()
                }
            })
            // return ajax
            // return axios.request(options)
    }

    generateUrl () {
        let baseUrl = this.getOption('baseUrl')
        let endPoint = this.getOption('endpoint') || ''
        let urlObj = new URL(this.removeTrailingSlash(baseUrl) + this.addLeadingSlash(endPoint))

        let params = this.getParams() || {}
        if (params) {
            Object.keys(params).forEach((key) => {
                urlObj.searchParams.append(key, params[key])
            })
        }
        const url = urlObj.toString()

        return url
    }

    removeTrailingSlash (string) {
        return string.replace(/\/+$/, '')
    }

    removeLeadingSlash (string) {
        return string.replace(/^\/+/, '')
    }

    addLeadingSlash (string) {
        if (string) {
            return '/' + this.removeLeadingSlash(string)
        }
        return string
    }

    /**
     * Get the XSRF-TOKEN from header
     */
    getXSRFToken () {
        return Cookies.get('XSRF-TOKEN')
    }

    /**
     * Get the csrf token from meta tag
     */
    getCSRFToken () {
        return $('meta[name="csrf"]').attr('content')
    }

    /**
     * Append the xsrf header
     *
     * @param {} options
     */
    appendCsrfHeader (options) {
        let xsrf = this.getXSRFToken()
        let headers = {}

        // If got xsrf token
        if (xsrf) {
            headers['X-XSRF-TOKEN'] = xsrf
        } else {
            // then get csrf token
            let csrf = this.getCSRFToken()
            headers['X-CSRF-TOKEN'] = csrf
        }
        options.headers = _.merge(options.headers, headers)
        return options
    }

    spoofMethod (method) {
        this.addHeader('X-HTTP-METHOD-OVERRIDE', method)
    }

    acceptJson () {
        this.addHeader('Accept', 'application/json')
    }

    setErrorHandler (handler, statusCode = 'Master') {
        let obj = {}
        obj[statusCode] = handler
        this.setOption('errorHandler', obj)
    }

    setSuccessHandler (handler) {
        this.setOption('successHandler', handler)
    }

    dontStartLoader () {
        this.disableStartLoader = true
    }

    dontStopLoader () {
        this.disableStopLoader = true
    }

    shouldStartLoader () {
        return !this.shouldNotStartLoader()
    }

    shouldDisableLoader () {
        return this.getOption('disableLoader')
    }

    shouldNotStartLoader () {
        return (this.shouldDisableLoader() || this.disableStartLoader)
    }

    shouldStopLoader () {
        return !this.shouldNotStopLoader()
    }

    shouldNotStopLoader () {
        return (this.shouldDisableLoader() || this.disableStopLoader)
    }
}
